export const RadarLoader = () => {
  return (
    <div className="relative w-screen h-screen rounded-full overflow-hidden bg-transparent">
      {/* Logo */}
      <img
        src="https://res.cloudinary.com/dvloxectq/image/upload/v1739930864/Multicook/oie_eLxgXKHUx4nU_ogymnd.png"
        alt="Logo"
        className="h-[250px] w-[250px] absolute top-[calc(20%-125px)] left-[calc(50%-125px)] object-contain opacity-30 transition-opacity duration-200 z-10"
      />

      {/* Radar Ray */}
      <div
        className="absolute inset-0 h-[280px] w-[280px] top-[calc(20%-140px)] left-[calc(50%-140px)] animate-spin-slow rounded-full pointer-events-none z-0"
        style={{
          background: `conic-gradient(rgba(0, 0, 0, 0.7) 0deg 90deg, transparent 90deg 360deg)`,
        }}
      ></div>
    </div>
  );
};
